import { IApplicationState } from '../../types/redux';

export const selectIsCallbackButtonEnabled = (state: IApplicationState) => state.showCallbackButton;
